import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as t } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialer",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, l, i, f, _, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--dialer"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Dialer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...l[0] || (l[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 7 1Zm0 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM7 4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 7 4Z",
      "clip-rule": "evenodd"
    }, null, -1),
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.01 2.034a.036.036 0 0 0-.003.016 7.98 7.98 0 0 0 .554 2.508l1.128-.94a.125.125 0 0 0 .041-.127l-.349-1.396A.125.125 0 0 0 3.26 2H2.083a.092.092 0 0 0-.065.023.035.035 0 0 0-.009.011ZM3 5.493l1.33-1.108c.332-.276.476-.718.371-1.136l-.349-1.397A1.125 1.125 0 0 0 3.26 1H2.083c-.577 0-1.106.457-1.074 1.1a9.101 9.101 0 0 0 2.674 5.94c2.217 2.22 4.922 2.773 6.137 2.912.67.077 1.18-.463 1.18-1.077V8.738c0-.516-.352-.966-.853-1.091l-1.439-.359a1.125 1.125 0 0 0-1.068.296L6.394 8.832A8.804 8.804 0 0 1 4.39 7.334 8.226 8.226 0 0 1 3 5.493Zm4.35 3.796a9.892 9.892 0 0 0 2.583.67.05.05 0 0 0 .023-.002.046.046 0 0 0 .017-.01.096.096 0 0 0 .026-.072V8.738a.125.125 0 0 0-.095-.121l-1.439-.359a.125.125 0 0 0-.118.033l-.997.998Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=dialer.js.map
